import React from "react";
import { useApi } from "../../../hooks/useApi";
import api from "../../../utils/api";
import "./Dashboard.scss";

const Dashboard = () => {
  const { data: productsData } = useApi(() => api.getAdminProducts({ limit: 1 }), []);
  const { data: ordersData } = useApi(() => api.getAdminOrders(), []);
  const { data: customersData } = useApi(() => api.getAdminCustomers(), []);

  const productCount = productsData?.pagination?.total || 0;
  const orderCount = ordersData?.orders?.length || 0;
  const customerCount = customersData?.customers?.length || 0;
  const revenue = ordersData?.orders?.reduce((sum, order) => sum + parseFloat(order.total || 0), 0) || 0;

  const stats = [
    { label: "Total Products", value: productCount.toString(), icon: "", color: "#3498db" },
    { label: "Total Orders", value: orderCount.toString(), icon: "", color: "#2ecc71" },
    { label: "Total Customers", value: customerCount.toString(), icon: "", color: "#e74c3c" },
    { label: "Revenue", value: `$${revenue.toFixed(2)}`, icon: "", color: "#f39c12" },
  ];

  return (
    <div className="admin-dashboard">
      <div className="stats-grid">
        {stats.map((stat, index) => (
          <div key={index} className="stat-card" style={{ borderTopColor: stat.color }}>
            {stat.icon && <div className="stat-icon">{stat.icon}</div>}
            <div className="stat-content">
              <div className="stat-value">{stat.value}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="dashboard-sections">
        <div className="dashboard-section">
          <h2>Recent Orders</h2>
          <div className="empty-state">
            <p>No recent orders</p>
          </div>
        </div>

        <div className="dashboard-section">
          <h2>Quick Actions</h2>
          <div className="quick-actions">
            <a href="/admin/products/new" className="action-btn">
              Add New Product
            </a>
            <a href="/admin/categories/new" className="action-btn">
              Add New Category
            </a>
            <a href="/admin/orders" className="action-btn">
              View All Orders
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
